import React from 'react';

const IssuesCell = ({ setCurrentElement, cellData, key, style, classNames, cellValue }) => {
  const _setCurrentElement = () => {
    // TODO: Add the ability to open up right panel by uncommenting this function
    // TODO: Need to figure out why company element type doesn't have props on it
    // if (cellData) {
    //   setCurrentElement(cellData.companyElement);
    // }
  }

  return (
    <div className={classNames} key={key} style={style} onClick={_setCurrentElement}>
      {cellValue}
    </div>
  );
}

export default IssuesCell;



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/IssuesBreakdown/IssuesCell.js